import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Segment, List, Header, Button } from 'semantic-ui-react';
import styled from 'styled-components';
import AuthResultSearchForm from './AuthResultSearchForm';
import MealApproveAccepterResult from './MealApproveAccepterResult';
import storage from 'helpers/storage';
class MealApproveAuth extends Component {
  state = {
    mainKey: 0,
    subKey: 0,
    accepter: null,
    empty: false
  };

  async componentWillMount() {
    const { mainKey } = this.state;
    const { sikdaeGroup, formFn, gIdx } = this.props;
    const sortArr = (fir, sec) => (fir.name < sec.name ? -1 : fir.name > sec.name ? 1 : 0);

    if (sikdaeGroup && sikdaeGroup.data && sikdaeGroup.data.group) {
      let { group } = sikdaeGroup.data;
      group.sort(sortArr);

      let agIdx = gIdx ? gIdx : group[mainKey].idx;
      await formFn.sikdaeGroupSearch(agIdx);
      await this.searchDemandKeyIndex();
      this.getAccepterList();
    }
  }

  // 정책들중 타입이 DEMAND인 첫번째 index를 찾아서 subkey로 넘김
  searchDemandKeyIndex = () => {
    const { sikdaePolicy, sikdaeGroup, pIdx } = this.props;
    if (sikdaePolicy && sikdaePolicy.data && sikdaePolicy.data.policy) {
      let { policy } = sikdaePolicy.data;
      let firActiveKey = null;

      const sortArr = (fir, sec) => (fir.name < sec.name ? -1 : fir.name > sec.name ? 1 : 0);

      if (!pIdx) {
        policy.sort(sortArr).some((pItem, idx) => {
          if (pItem.type === 'DEMAND' || pItem.demand) {
            if (pItem.demand.type === 'CONFIRM') {
              firActiveKey = idx;
            }
            return pItem.demand.type === 'CONFIRM';
          }
        });
      } else {
        firActiveKey = filterPolicy.sort(sortArr).findIndex((pItem) => pItem.idx === pIdx);
      }

      this.setState({ subKey: firActiveKey });
    }
  };

  // 승인자 리스트 조회
  getAccepterList = () => {
    const { mainKey, subKey } = this.state;
    const { sikdaePolicy, sikdaeGroup, formFn } = this.props;
    if (sikdaeGroup && sikdaeGroup.data && sikdaeGroup.data.group) {
      const { group } = sikdaeGroup.data;
      const { name, idx } = group[mainKey];

      this.setState({
        groupName: name,
        groupIdx: idx
      });
    }
    if (sikdaePolicy && sikdaePolicy.data && sikdaePolicy.data.policy) {
      const { policy } = sikdaePolicy.data;

      if (policy.length > 0) {
        let pItem = policy[subKey];
        if (pItem) {
          if (pItem.demand.accepter !== 'ALL') {
            formFn.accepterList(pItem.demand.idx);
          }

          this.setState({
            policyName: pItem.name,
            demandIdx: pItem.demand.idx,
            policyIdx: pItem.idx,
            accepter: pItem.demand.accepter,
            empty: false
          });
        } else {
          this.setState({
            empty: true,
            policyName: ''
          });
        }
      } else {
        this.setState({
          policyName: '',
          empty: true
        });
      }
    }
  };

  // 그룹 조회
  onClickGroup = async (gIdx, idx, item) => {
    const { formFn } = this.props;
    const beforeAccepter = storage.get('beforeAccepter');

    storage.remove('beforeAccepter');

    // if (sikdaeGroup && sikdaeGroup.data) {
    //   const { group } = sikdaeGroup.data;
    //   group.some(item => {
    //     if (item.idx === gIdx) {
    //       this.setState({ groupName: item.name, groupIdx: item.idx });
    //       return true;
    //     }
    //   });
    // }

    await this.setState({ mainKey: idx });
    // 정책 조회
    await formFn.sikdaeGroupSearch(gIdx);
    await this.searchDemandKeyIndex();

    // 승인자 조회
    this.getAccepterList();
  };

  // 정책 조회
  onClickPolicy = async (idx) => {
    await this.setState({ subKey: idx });

    this.getAccepterList(idx);
    this.getAccepterList();
  };

  //확인
  submitForm = (e) => {
    // e.preventDefault();
    this.getAccepterList();
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  render() {
    const { mainKey, subKey, groupName, policyName, demandIdx, groupIdx, policyIdx, accepter, empty } = this.state;
    const { sikdaeGroup, sikdaePolicy, formFn } = this.props;
    const { division, approveAccepterMeal } = this.props;
    const link = '/main/mealApproveManagement';
    const params = {
      groupName,
      policyName,
      demandIdx,
      groupIdx,
      policyIdx,
      accepter
    };

    const sortArr = (fir, sec) => (fir.name < sec.name ? -1 : fir.name > sec.name ? 1 : 0);
    let itemHeader = `${groupName} > ${policyName}`;

    return (
      <StyledGroup horizontal>
        <StyledGroupItem style={{ minWidth: 200, maxWidth: 200 }}>
          <StyledItemHeader as="h4">식대그룹</StyledItemHeader>
          {sikdaeGroup && sikdaeGroup.data && sikdaeGroup.data.group && (
            <StyledList>
              {sikdaeGroup.data.group.sort(sortArr).map((gItem, idx) => (
                <StyledListItem key={gItem.idx}>
                  <Button
                    className={mainKey === idx ? 'active' : ''}
                    onClick={() => this.onClickGroup(gItem.idx, idx, gItem)}
                  >
                    {gItem.name}
                  </Button>
                </StyledListItem>
              ))}
            </StyledList>
          )}
        </StyledGroupItem>

        <StyledGroupItem style={{ minWidth: 200, maxWidth: 200 }}>
          <StyledItemHeader as="h4">식대정책</StyledItemHeader>
          {sikdaePolicy && sikdaePolicy.data && (
            <Fragment>
              {sikdaePolicy.data.policy.length > 0 ? (
                <Fragment>
                  {sikdaePolicy.data.policy.sort(sortArr).map((pItem, idx) => (
                    <StyledListItem key={pItem.idx}>
                      {pItem.type === 'DEMAND' || pItem.demand ? (
                        <Fragment>
                          {pItem.demand.type === 'CONFIRM' ? (
                            <Button className={subKey === idx ? 'active' : ''} onClick={() => this.onClickPolicy(idx)}>
                              {pItem.name}
                            </Button>
                          ) : (
                            <Button className="disabled">{pItem.name}</Button>
                          )}
                        </Fragment>
                      ) : (
                        <Button className="disabled">{pItem.name}</Button>
                      )}
                    </StyledListItem>
                  ))}
                </Fragment>
              ) : (
                <StyledEmpty>해당 정책이 없습니다.</StyledEmpty>
              )}
            </Fragment>
          )}
        </StyledGroupItem>

        <StyledGroupItem>
          <StyledItemHeader as="h4">
            {itemHeader}
            <StyledItemAuthButton
              color="black"
              inverted
              style={{ width: 150 }}
              onClick={() => formFn.movePage(link, params)}
            >
              승인권한 관리하기
            </StyledItemAuthButton>
          </StyledItemHeader>

          <AuthResultSearchForm
            division={formFn.division}
            handleSubmit={this.submitForm}
            handleEntSubmit={this.handleEntSubmit}
          />
          <MealApproveAccepterResult
            accepter={accepter}
            empty={empty}
            checkInput={false}
            approveAccepterList={approveAccepterMeal}
            authApproveInfo={params}
          />
        </StyledGroupItem>
      </StyledGroup>
    );
  }
}

const StyledGroup = styled(Segment.Group)`
  &&&& {
    border: 0 none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    border-left: solid 1px #dcdcdc;
    border-right: solid 1px #dcdcdc;
    border-bottom: solid 1px #dcdcdc;
  }
`;

const StyledGroupItem = styled(Segment)`
  &&&& {
    padding: 0;
    border-radius: 0;
    height: 80vh;
  }
`;

const StyledItemHeader = styled(Header)`
  &&&& {
    position: relative;
    margin: 0;
    padding: 10px 16px;
    height: 40px;
    font-size: 14px;
    background-color: #f8f8f8;
    border-top: solid 1px #dcdcdc;
    border-bottom: solid 1px #dcdcdc;
  }
`;

const StyledItemAuthButton = styled(Button)`
  &&&& {
    position: absolute;
    top: 3px;
    right: 24px;
    padding: 9px 0;
  }
`;

const StyledEmpty = styled.div`
  text-align: center;
  padding: 10px;
`;

const StyledList = styled(List)`
  &&&& {
    margin: 0;
  }
`;

const StyledListItem = styled(List.Item)`
  &&&& {
    border-bottom: solid 1px #dcdcdc;
    color: #000;
    font-size: 14px;
    font-weight: bold;
    padding: 0;

    &.active {
      background-color: #1db53a;
      color: #fff;
    }
    &.disabled {
      background-color: #eee;
      color: rgba(0, 0, 0, 0.6);
      cursor: not-allowed;
    }

    & button {
      background: transparent;
      margin: 0;
      width: 100%;
      padding: 12px 16px;
      height: 40px;
      text-align: left;
    }
  }
`;

MealApproveAuth = connect((state) => ({
  depth: state.commons.depth,
  // text: state.commons.text,
  // auth: state.commons.auth
  sikdaePolicy: state.commons.sikdaePolicy,
  sikdaeGroup: state.commons.sikdaeGroup,
  approveAccepterMeal: state.sikdae.approveAccepterMeal
}))(MealApproveAuth);

export default MealApproveAuth;
